import { render, staticRenderFns } from "./Current.vue?vue&type=template&id=f731bf70&scoped=true&"
import script from "./Current.vue?vue&type=script&lang=js&"
export * from "./Current.vue?vue&type=script&lang=js&"
import style0 from "./Current.vue?vue&type=style&index=0&id=f731bf70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f731bf70",
  null
  
)

export default component.exports